export default "__VITE_ASSET__DOwsua1g__"